<template>
  <div>
    <ContentHeader title="Edit Broker" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()">
                <div class="card-body">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="account_number_error"
                  >
                    <p class="mb-0">
                      {{ account_number_error }}
                    </p>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="form-group">
                    <label for="broker-id">Broker</label>
                    <select
                      id="broker-id"
                      class="form-control"
                      :class="{
                        'border-danger': $v.payload.broker_id.$error,
                      }"
                      v-model="payload.broker_id"
                    >
                      <option
                        v-for="broker in brokers"
                        :key="broker.id"
                        :value="broker.id"
                      >
                        {{ broker.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="account-number">Account Number</label>
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'border-danger':
                          ($v.payload.trader_password.$error &&
                            !$v.payload.account_number.required) ||
                          !$v.payload.account_number.numeric,
                      }"
                      id="account-number"
                      placeholder="Enter Account Number"
                      v-model="payload.account_number"
                    />
                    <div
                      class="text-danger"
                      v-if="
                        !$v.payload.account_number.required &&
                        $v.payload.trader_password.$error
                      "
                    >
                      <small>Account Number Required</small>
                    </div>
                    <div
                      class="text-danger"
                      v-if="!$v.payload.account_number.numeric"
                    >
                      <small>This Field Must be Number</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="trader-password">Trader Password</label>
                    <div class="input-group">
                      <input
                        :type="show.password ? 'text' : 'password'"
                        class="form-control"
                        :class="{ 'border-danger': $v.payload.trader_password.$error }"
                        placeholder="Password"
                        v-model="payload.trader_password"
                      />
                      <div class="input-group-append">
                        <div
                          class="input-group-text"
                          :class="{ 'border-danger': $v.payload.trader_password.$error }"
                          @click="showPassword()"
                        >
                          <span
                            class="fas"
                            :class="{
                              'fa-eye': !show.password,
                              'fa-eye-slash': show.password,
                            }"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-danger"
                      v-if="$v.payload.trader_password.$error"
                    >
                      <small>Trader Password Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="broker-server">Broker Server</label>
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'border-danger': $v.payload.broker_server.$error,
                      }"
                      id="broker-server"
                      placeholder="Enter Broker Server"
                      v-model="payload.broker_server"
                    />
                    <div
                      class="text-danger"
                      v-if="$v.payload.broker_server.$error"
                    >
                      <small>Broker Server Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="broker-server">Status</label>
                    <select v-model="payload.is_active" class="form-control">
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  </div>
                </div>
                <div class="card-footer">
                  <a
                    class="btn btn-outline-danger mr-3"
                    href="#"
                    @click="$router.go(-1)"
                  >
                    Back
                  </a>
                  <button
                    type="submit"
                    href="#"
                    class="btn btn-success btn-block"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiClient from "@/services/ApiServices";
import apiBroker from "@/services/BrokerApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  components: {
    ContentHeader,
  },
  data() {
    return {
      brokers: null,
      robot_id: null,
      show: {
        password: false,
      },
      payload: {
        broker_id: "",
        account_number: "",
        trader_password: "",
        broker_server: "",
        is_active: "",
      },
      account_number_error: "",
      submitStatus: null,
    };
  },

  validations: {
    payload: {
      broker_id: {
        required,
      },
      account_number: {
        required,
        numeric,
      },
      trader_password: {
        required,
      },
      broker_server: {
        required,
      },
    },
  },

  async mounted() {
    try {
      let brokerList = await apiBroker.get(`/`);
      this.brokers = brokerList.data.data;

      let brokerDetail = await apiClient.get(
        `broker/${this.$route.params.id}/`
      );
      this.payload.broker_id = brokerDetail.data.data.broker_id;
      this.payload.account_number = brokerDetail.data.data.account_number;
      this.payload.trader_password = brokerDetail.data.data.trader_password;
      this.payload.broker_server = brokerDetail.data.data.broker_server;
      this.payload.is_active = brokerDetail.data.data.is_active;
    } catch (error) {
      this.$toasted.show(error.message, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 4000,
      });
    }
  },

  methods: {
    
    showPassword() {
      this.show.password = !this.show.password;
    },
    async handleCreateData() {
      let data = new FormData();

      data.append("broker_id", this.payload.broker_id);
      data.append("account_number", this.payload.account_number);
      data.append("trader_password", this.payload.trader_password);
      data.append("broker_server", this.payload.broker_server);
      data.append("is_active", this.payload.is_active);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        try {
          let response = await apiClient.put(
            `broker/${this.$route.params.id}/`,
            data
          );
          this.submitStatus = "OK";
          this.account_number_error = "";

          this.$swal("Updated!", "Data has been updated.", "success").then(
            () => {
              this.$router.push({
                name: "RobotDetails",
                params: { id: response.data.data.robot_id },
              });
            }
          );
        } catch (error) {
          this.submitStatus = "ERROR";
          this.account_number_error = error.data.data.account_number[0];
        }
      }
    },
  },
};
</script>
